import "./../FooterAll/FooterAll.css";
import logowhite from "./../../../Assets/synergy-logo-footer.png"; 
import { FaFacebookF, FaTwitter, FaInstagram, FaLinkedin, FaYoutube } from "react-icons/fa";
import { MdOutlineKeyboardArrowRight, MdOutlineEmail, MdOutlineAccessTime } from "react-icons/md";
import { LuPhone } from "react-icons/lu";
import { Link } from "react-router-dom";
import { useState } from "react";
import { trackEvent } from "../../utils/trackEvent";
import { SERVICE_LINKS } from "../Navbarsynergtech/Navbarsynergtech";

function FooterAll() {
           const [email, setEmail] = useState("");   // store the input value
           const [message, setMessage] = useState(""); // optional: feedback message

           const handleSubscribe = async (e) => {
           e.preventDefault(); // prevent form reload if inside <form>

    try {
      const res = await fetch(`${process.env.REACT_APP_BASE_URL}/api/newsletter/subscribe`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email }),
      });

      const data = await res.json();
      if (res.ok) {
        trackEvent("newsletter_submitted");
      }
      setMessage(data.message || "Subscription complete!");
      setEmail(""); // clear input after success
    } catch (error) {
      console.error("Error subscribing:", error);
      setMessage("Something went wrong. Try again.");
    }
  };

  
  return (
    <div className="main_div_footer">
      <div className="row p-0 m-0">
        <div className="col-lg-2 col-md-12 col-sm-12 col-12"></div>
        <div className="col-lg-8 col-md-12 col-sm-12 col-12">
          <div className="row p-0 m-0">
            <div className="col-lg-4 col-md-6 col-sm-12 col-12 mb-4">
              <img src={logowhite || "/placeholder.svg"} width="250" height="90" className="logo_white_footer" alt="360 SynergyTech logo" loading="lazy" />
              <p className="para_below_logo">
                360 SynergyTech drives growth with custom software, AI, and cloud services. Innovate smarter today
              </p>
              <div className="d-flex flex-row social-media-container">
                <a href="https://x.com/360SynergyTech" className="btn_social_media_links" aria-label="Visit our Twitter page">
                  <FaTwitter />
                </a>
                <a href="https://www.facebook.com/360SynergyTech/" className="btn_social_media_links" aria-label="Visit our Facebook page">
                  <FaFacebookF />
                </a>
                <a href="https://www.instagram.com/360synergytech/" className="btn_social_media_links" aria-label="Visit our Instagram page">
                  <FaInstagram />
                </a>
                <a href="https://pk.linkedin.com/company/360synergytech" className="btn_social_media_links" aria-label="Visit our LinkedIn page">
                  <FaLinkedin />
                </a>
                <a href="https://www.youtube.com/@360synergytech" className="btn_social_media_links" aria-label="Visit our YouTube channel">
                  <FaYoutube />
                </a>
              </div>
            </div>

            <div className="col-lg-2 col-md-3 col-sm-6 col-12 mb-4">
              <p className="services_heading_footer">Company</p>
              <div className="hr_line_blue_footer" />
              <div className="links-container">
                <Link to="/about">
                  <p className="para_below_services_footer">
                    <MdOutlineKeyboardArrowRight /> About
                  </p>
                </Link>
                <Link to="/team">
                  <p className="para_below_services_footer">
                    <MdOutlineKeyboardArrowRight /> Team
                  </p>
                </Link>
                <Link to="/portfolio">
                  <p className="para_below_services_footer">
                    <MdOutlineKeyboardArrowRight /> Portfolio
                  </p>
                </Link>
                <Link to="/case-studies">
                  <p className="para_below_services_footer">
                    <MdOutlineKeyboardArrowRight /> Case studies
                  </p>
                </Link>
                <Link to="/blog">
                  <p className="para_below_services_footer">
                    <MdOutlineKeyboardArrowRight /> Blog
                  </p>
                </Link>
                <Link to="/careers">
                  <p className="para_below_services_footer">
                    <MdOutlineKeyboardArrowRight /> Careers
                  </p>
                </Link>
                <Link to="/contact">
                  <p className="para_below_services_footer">
                    <MdOutlineKeyboardArrowRight /> Contact
                  </p>
                </Link>
                <Link to="/privacy-policy">
                  <p className="para_below_services_footer">
                    <MdOutlineKeyboardArrowRight /> Privacy Policy
                  </p>
                </Link>
              </div>
            </div>

            <div className="col-lg-3 col-md-3 col-sm-6 col-12 mb-4">
              <p className="services_heading_footer">Services</p>
              <div className="hr_line_blue_footer" />
              <div className="links-container">
                {SERVICE_LINKS.map(({ to, label }) => (
                  <Link key={to} to={to}>
                    <p className="para_below_services_footer">
                      <MdOutlineKeyboardArrowRight /> {label}
                    </p>
                  </Link>
                ))}
              </div>
            </div>

            <div className="col-lg-3 col-md-3 col-sm-6 col-12 mb-4">
              <p className="services_heading_footer">Newsletter</p>
              <div className="hr_line_blue_footer" />
              <p className="para_below_logo newsletter-description">
                Subscribe for updates on web development, AI, cloud, and tech trends — with tips and offers
              </p>

               {/* ------------Email field for email submission--------------- */}


              <div className="newsletter-form">
                 <form onSubmit={handleSubscribe} className="d-flex gap-2">
               <input
                className="input_white_newsletter"
                type="email"
                aria-label="Email address for the newsletter"
                placeholder="Enter Your Email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
               />
                <button
                 className="submit_newsletter_btn"
                 type="submit"
                 aria-label="Submit newsletter subscription"
                 >
                Submit Now
               </button>
               </form>

             {message && <p className="mt-2">{message}</p>}
              </div>

               {/*   this was the previous code for email submission 
               <input className="input_white_newsletter" placeholder="Enter Your Email" />
                <button className="submit_newsletter_btn" aria-label="Submit newsletter subscription">
                  Submit Now
                </button> */}

               {/* ------------Email field for email submission--------------- */}
            </div>
          </div>

          <div className="grey_line" />

          <div className="row m-0 p-0 contact-info-row">
            <div className="col-lg-4 col-md-4 col-sm-12 col-12 mb-3">
              <div className="d-flex flex-row align-items-center contact-item">
                <button className="blue_btn_email" aria-label="Contact us via email">
                  <MdOutlineEmail />
                </button>
                <div className="contact-text">
                  <p className="email_heading_footer">Email</p>
                  <p className="email_para_footer">info@360synergytech.com</p>
                </div>
              </div>
            </div>

            <div className="col-lg-4 col-md-4 col-sm-12 col-12 mb-3">
              <div className="d-flex flex-row align-items-center contact-item">
                <button className="blue_btn_email" aria-label="Contact us via phone">
                  <LuPhone />
                </button>
                <div className="contact-text">
                  <p className="email_heading_footer">Phone</p>
                  <p className="email_para_footer">+92 324 9925737</p>
                </div>
              </div>
            </div>

            <div className="col-lg-4 col-md-4 col-sm-12 col-12 mb-3">
              <div className="d-flex flex-row align-items-center contact-item">
                <button className="blue_btn_email" aria-label="Our working hours">
                  <MdOutlineAccessTime />
                </button>
                <div className="contact-text">
                  <p className="email_heading_footer">Working Hours</p>
                  <p className="email_para_footer">Mon - Fri: 09.00am - 10.00 pm</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="col-lg-2 col-md-12 col-sm-12 col-12"></div>
      </div>
    </div>
  );
}

export default FooterAll;